import React from "react";

interface SidebarSeparatorProps {
  className?: string;
}

/**
 * SidebarSeparator - Horizontal divider line
 *
 * @param className - Additional CSS classes
 */
export function SidebarSeparator({ className = "" }: SidebarSeparatorProps) {
  return (
    <hr
      className={`
        w-full border-0 border-t border-solid border-primary
        my-sm
        ${className}
      `.trim()}
      role="separator"
    />
  );
}
